import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../styles/ProfesionalList.css";

const ProfesionalesList = () => {
  const [profesionales, setProfesionales] = useState([]);
  const [especialidades, setEspecialidades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch profesionales
  const fetchProfesionales = async () => {
    try {
      const response = await axios.get("https://vortexcode.cl/api/profesional", {
        params: { limit: 10 },
      });
      setProfesionales(response.data.slice(0, 10)); // Limitar a 10 profesionales destacados
    } catch (err) {
      setError("Hubo un error al obtener los profesionales");
      console.error(err);
    }
  };

  // Fetch especialidades
  const fetchEspecialidades = async () => {
    try {
      const response = await axios.get("https://vortexcode.cl/api/especialidad");
      setEspecialidades(response.data);
    } catch (err) {
      setError("Hubo un error al obtener las especialidades");
      console.error(err);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      await Promise.all([fetchProfesionales(), fetchEspecialidades()]);
      setLoading(false);
    };
    fetchData();
  }, []);

  // Obtener el nombre de la especialidad por id
  const getEspecialidadNombre = (idEspecialidad) => {
    const especialidad = especialidades.find(
      (esp) => esp.id_especialidad === idEspecialidad
    );
    return especialidad ? especialidad.nombre_especialidad : "Especialidad no especificada";
  };

  return (
    <div className="container my-5" id="profesionalesList">
      <h2 className="text-center mb-4">PROFESIONALES DESTACADOS</h2>

      {loading && <p className="text-center">Cargando...</p>}
      {error && <p className="text-danger text-center">{error}</p>}

      <div className="profesionales-carousel-wrapper">
        <button
          id="especialidadesFlechaIzq"
          onClick={() => {
            document.querySelector("#profesionales-carousel-track").scrollBy({ left: -200, behavior: "smooth" });
          }}
        >
          ❮
        </button>

        <div id="profesionales-carousel-track" className="carousel-track">
          {profesionales.map((profesional) => (
            <div key={profesional.id_profesional} className="profesional-card">
              <Link to={`/profesional/${profesional.id_profesional}`} className="card-link">
                <div className="profesional-circle">
                  <img
                    src={profesional.img_profesional}
                    alt={profesional.nombre_profesional}
                    className="professional-img"
                  />
                </div>
                <p className="nombre">
                  {profesional.nombre_profesional} {profesional.apaterno_profesional}
                </p>
                <p className="especialidad">
                  {getEspecialidadNombre(profesional.especialidad_id_especialidad)}
                </p>
              </Link>
            </div>
          ))}
          <Link to="/profesionales" id="especialidadesVerTodo">
            Ver todo
          </Link>
        </div>

        <button
          id="especialidadesFlechaDer"
          onClick={() => {
            document.querySelector("#profesionales-carousel-track").scrollBy({ left: 200, behavior: "smooth" });
          }}
        >
          ❯
        </button>
      </div>
    </div>
  );
};

export default ProfesionalesList;